import axios from 'axios'
import router from '../router'

const api = axios.create({
  baseURL: '/api/admin',
  withCredentials: true,
})

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (
      error.response?.status === 401 &&
      !error.config?._skipAuthRedirect &&
      router.currentRoute.value.name !== 'login'
    ) {
      router.push({ name: 'login' })
    }
    return Promise.reject(error)
  },
)

export default api
